import DataBlockLabel from "../account/DataBlockLabel";
import countryList from "../../public/content/countries/country-select-list.json";
import {useForm} from "react-hook-form";
import ToastService from "../../services/Toast.Service";
import { useRouter } from "next/router";
import InvoiceServices from "../../services/Invoice.services";


export default function CreateCustomerForm({closePopupFn, jwtToken, invoice})
{
    const router = useRouter();

    const {
        register,
        handleSubmit,
        setError,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: {
            company_name: "",
            kvk: "",
            address: {
                line1: "",
                line2: "",
                postal_code: "",
                city: "",
                country: "",
            },
            phone_number: "",
            email: "",
            website: "",
            color_code: "",
            margin: "",
            contact: {
                salutation: "",
                first_name: "",
                last_name: "",
                phone_number: "",
                email: "",
            },
        },
    });

    const onSubmit = (data) => {
        const promise = fetch(process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/clients/create", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify(data),
        })
            .then((response) => response)
            .then(async (data) => {
                return {
                    ok: data.ok,
                    data: await data.json(),
                };
            })
            .then((data) => {
                if (!data.ok) {
                    throw data.data.message;
                }

                InvoiceServices.attachClient(invoice, data.data.uid, jwtToken)
                router.reload();
            });

        ToastService.promiseToast(promise);
    };

    return (<form
        id={'create-customer-form'}
        onSubmit={handleSubmit(onSubmit)}
        className=" space-y-4 ml-0"
    >
        <div className="flex flex-col">
            <DataBlockLabel text="Klantgegevens" />
            <div className="mt-2 bg-white py-5 rounded-tl-lg rounded-br-lg space-y-3">
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Aanhef</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <select
                                {...register("contact.salutation")}
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors?.contact?.salutation
                                        ? "border-red-500"
                                        : "border-white"
                                }`}
                            >
                                <option disabled selected>
                                    Aanhef
                                </option>
                                <option value="Dhr.">Dhr.</option>
                                <option value="Mvr.">Mvr.</option>
                                <option value="other">other</option>
                            </select>
                            {errors.salutation?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Voornaam*</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <input
                                type="text"
                                {...register("contact.first_name", {
                                    required: true,
                                })}
                                placeholder="Voornaam"
                                id="contact.first_name"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors?.contact?.first_name
                                        ? "border-red-500"
                                        : "border-white"
                                }`}
                            />
                            {errors?.contact?.first_name?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Achternaam*</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <input
                                type="text"
                                {...register("contact.last_name", {
                                    required: true,
                                })}
                                placeholder="Achternaam"
                                id="contact.last_name"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors?.contact?.last_name
                                        ? "border-red-500"
                                        : "border-white"
                                }`}
                            />
                            {errors?.contact?.last_name?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Telefoon</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <input
                                type="text"
                                {...register("phone_number", {
                                    required: false,
                                })}
                                placeholder="Telefoon"
                                id="phone_number"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors.phone_number
                                        ? "border-red-500"
                                        : "border-white"
                                }`}
                            />
                            {errors.phone_number?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>E-mail*</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <input
                                type="email"
                                {...register("email", {
                                    required: true,
                                })}
                                placeholder="E-mail"
                                id="email"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors.email ? "border-red-500" : "border-white"
                                }`}
                            />
                            {errors.email?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Straatnaam*</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="sm:flex gap-x-2 w-full">
                            <div className="w-full flex-grow">
                                <input
                                    type="text"
                                    {...register("address.line1", {
                                        required: true,
                                    })}
                                    placeholder="Straatnaam"
                                    id="address.line1"
                                    className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                        errors?.address?.line1
                                            ? "border-red-500"
                                            : "border-white"
                                    }`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Huisnummer*</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="sm:flex gap-x-2 w-full">
                            <div className="w-full flex-grow">
                                <input
                                    type="number"
                                    {...register("address.houseNumber", {
                                        required: true,
                                    })}
                                    placeholder="Huisnummer"
                                    id="address.houseNumber"
                                    className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                        errors?.address?.houseNumber
                                            ? "border-red-500"
                                            : "border-white"
                                    }`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Toevoeging</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="sm:flex gap-x-2 w-full">
                            <div className="w-full flex-grow">
                                <input
                                    type="text"
                                    {...register("address.line2", {
                                        required: false,
                                    })}
                                    placeholder="Toevoeging"
                                    id="address.line2"
                                    className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                        errors?.address?.line2
                                            ? "border-red-500"
                                            : "border-white"
                                    }`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Postcode*</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <input
                                type="text"
                                {...register("address.postal_code", {
                                    required: true,
                                })}
                                placeholder="Postcode"
                                id="address.postal_code"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors?.address?.postal_code
                                        ? "border-red-500"
                                        : "border-white"
                                }`}
                            />
                            {errors?.address?.postal_code?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Plaats*</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <input
                                type="text"
                                {...register("address.city", {
                                    required: true,
                                })}
                                placeholder="Plaats"
                                id="address.city"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors?.address?.city
                                        ? "border-red-500"
                                        : "border-white"
                                }`}
                            />
                            {errors?.address?.city?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Land*</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <select
                                name="land"
                                id=""
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors?.address?.country
                                        ? "border-red-500"
                                        : "border-white"
                                }`}
                                {...register("address.country", {
                                    required: true,
                                })}
                            >
                                <option disabled selected>
                                    Selecteer een land
                                </option>
                                {Object.keys(countryList).map((item, i) => (
                                    <option value={item} key={item}>
                                        {countryList[item]}
                                    </option>
                                ))}
                            </select>
                            {errors?.address?.country?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="flex flex-col">
            <DataBlockLabel text="Optioneel: Bedrijfsgegevens" />
            <div className="mt-2 bg-white py-5 rounded-tl-lg rounded-br-lg space-y-3">
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>Bedrijfsnaam</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <input
                                type="text"
                                {...register("company_name", {
                                    required: false,
                                })}
                                placeholder="Naam"
                                id="company_name"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors.company_name
                                        ? "border-red-500"
                                        : "border-white"
                                }`}
                            />
                            {errors.company_name?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center">
                    <div className="w-1/3 shrink-0">
                        <p className="text-sm text-olaf-green-500">
                            <strong>KVK</strong>
                        </p>
                    </div>
                    <div className="ml-4 w-2/3 flex items-center">
                        <div className="w-full">
                            <input
                                type="text"
                                {...register("kvk", {
                                    required: false,
                                })}
                                placeholder="Kvk nummer"
                                id="kvk"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                    errors.kvk ? "border-red-500" : "border-white"
                                }`}
                            />
                            {errors.kvk?.type === "required" && (
                                <div className="group shrink-0 absolute right-2">
                                    <img
                                        src="/icons/form-error.svg"
                                        className="w-4 h-4"
                                        alt=""
                                    />
                                    <span className="absolute bottom-8 -right-2 text-sm opacity-0 shadow-xl w-max pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto px-4 py-2 bg-white flex border-b-2 border-red-500">
                            Dit veld is vereist
                          </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button
            form={'create-customer-form'}
            type="submit"
            className="mt-4 cursor-pointer w-[150px] mx-auto h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] bg-olaf-green-500 text-white text-sm font-bold"
        >
            Opslaan
        </button>
    </form>);
}